/**
 * @Description: 项目配置入口文件
 * @Author: jiangang
 * @Date: 2022-03-04
 * @LastEditTime: 14:18:43
 * @LastEditTime: 14:18
 */
const baseUrl = process.env.VUE_APP_BASE_URL || 'https://iot-platform-api.newhopelh.cn/';
console.log(process.env.VUE_APP_TITLE);
// console.log('baseUrl', process.env.VUE_APP_BASE_URL)
const agentList = {
  // 本地联调临时配置
  // '/api/hcm-system/': {
  //   target: 'http://172.18.11.199:8082/',
  //   changeOrigin: true,
  //   pathRewrite: { '^/api/hcm-system': '/api' }
  // },
  '/api/': {
    target: baseUrl,
    changeOrigin: true,
    // headers: {
    //   Cookie: 'X-IoT-Access-Auth-Token=9FC8USWXRPUfwco1y0mKmUCa2oIGWM88goqxNCGE7mkeUBcM0T7pa6OOCaghdPMJ'
    // }
  }
}

module.exports = {
  // apiBase: hostMap[env] && hostMap[env].apiBase,
  apiBase: baseUrl,
  outputDir: 'dist',
  proxy: {
    ...agentList
  },
  publicPath: '/'
};
